import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AnnexesViewComponent } from "./components/annexes-view/annexes-view.component";
import { VisitApiService } from "./services/visit-api.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { FlexLayoutModule } from "@angular/flex-layout";

@NgModule({
  declarations: [
    AnnexesViewComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatTabsModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSortModule,
    MatButtonModule,
    FlexLayoutModule,
  ],
  providers: [
    VisitApiService
  ],
  exports: [
    AnnexesViewComponent
  ]
})
export class InovaCoreVisitModule { }
